import Vue from 'vue';
import inviteServices from 'services/invites';
import { EventBus } from 'utils/event-bus';

// This is the only place where an invite code is processed
// and subsequently redirects the user to the appropriate location
export const useInviteCode = async (context, invite_code) => {
  let route = { name: 'dashboard' };
  try {
    const response = await inviteServices.joinWithCode(invite_code);
    const { courseID, roundtableID, liveDiscussionID, invite_context } = response.data;
    if (invite_context === 'roundtable') {
      route = { name: 'roundtable.prompt', params: { roundtableID, courseID } };
    } else if (invite_context === 'live_discussion') {
      route = { name: 'live-discussion.index', params: { liveDiscussionID, courseID } };
    }
    return Vue.router.push(route);
  } catch (error) {
    console.error(error.response.data.error, error);
    const message = error.response.data.error;
    EventBus.$emit('createToast', { type: 'Error', message: message, time: 5000 });
    return;
  }
};

export const validateCode = (context, invite_code) =>
  inviteServices.validateCode(invite_code);

export const getEmailSuffixesOfSchool = (_, code) => {
  return inviteServices
    .getEmailSuffixesOfSchool(code)
    .then((res) => {
      if (res.data)
        return res.data;
    })
    .catch(err => console.error(err));
};


// WEBPACK FOOTER //
// ./src/app/store/actions/invites.js